// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Tenants_tableWrapper__thAGU","buttonObra":"Tenants_buttonObra__zFTWh"};